export const CONSULTATION_CONSTANT = {
  // テーブル名
  TABLE: 'consultation',
  // csvファイル名
  CSV_FILENAME: 'consultation',
};
